import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Stack,
	Typography,
} from '@mui/material';
import React from 'react';
import { AutofillCallResponse } from '../../../api/integrations';
import {
	AUTOFILL_SEQUENCE_LABEL,
	DELETE_CONFIRM_LABEL,
	DELETE_CONFIRM_MESSAGE,
	DELETE_LABEL,
	INTEGRATION_DELETE_ACTION_TEXT,
	INTEGRATION_DELETE_CANCEL_TEXT,
} from '../../../data/constants';
import { handleModalClose } from '../../../utils/handleModalClose';

interface Props {
	open: boolean;
	autofillSequence: AutofillCallResponse;
	onCancel: () => void;
	onDelete: (autofillSequence: AutofillCallResponse) => void;
	isLoading: boolean;
}

export default function ConfirmDeleteAutofillSequenceModal({
	open,
	autofillSequence,
	onCancel,
	onDelete,
	isLoading,
}: Props) {
	return (
		<Dialog open={open} onClose={(e, r) => handleModalClose(r, onCancel)}>
			<DialogTitle>{DELETE_LABEL(AUTOFILL_SEQUENCE_LABEL)}</DialogTitle>
			<DialogContent>
				<Stack alignItems='flex-start' direction='column' spacing={0}>
					<Typography>{DELETE_CONFIRM_LABEL('this')}</Typography>
					<Typography>{DELETE_CONFIRM_MESSAGE()}</Typography>
				</Stack>
			</DialogContent>
			<DialogActions sx={{ m: 2 }}>
				<Button onClick={onCancel} color='neutralButton'>
					{INTEGRATION_DELETE_CANCEL_TEXT()}
				</Button>
				<Button
					color='error'
					variant='contained'
					onClick={() => !isLoading && onDelete(autofillSequence)}
				>
					{!isLoading ? (
						INTEGRATION_DELETE_ACTION_TEXT()
					) : (
						<CircularProgress size={20} style={{ color: 'white' }} />
					)}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
